var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableCalendarLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.293 10.707C5.19981 10.6143 5.12587 10.5042 5.0754 10.3829C5.02494 10.2615 4.99897 10.1314 4.99897 10C4.99897 9.86859 5.02494 9.73848 5.0754 9.61715C5.12587 9.49581 5.19981 9.38565 5.293 9.293L9.536 5.05C9.7246 4.86784 9.9772 4.76705 10.2394 4.76933C10.5016 4.7716 10.7524 4.87677 10.9378 5.06218C11.1232 5.24759 11.2284 5.4984 11.2307 5.7606C11.233 6.0228 11.1322 6.2754 10.95 6.464L8.414 9H14C14.2652 9 14.5196 9.10536 14.7071 9.29289C14.8946 9.48043 15 9.73478 15 10C15 10.2652 14.8946 10.5196 14.7071 10.7071C14.5196 10.8946 14.2652 11 14 11H8.414L10.95 13.536C11.1322 13.7246 11.233 13.9772 11.2307 14.2394C11.2284 14.5016 11.1232 14.7524 10.9378 14.9378C10.7524 15.1232 10.5016 15.2284 10.2394 15.2307C9.9772 15.233 9.7246 15.1322 9.536 14.95L5.293 10.707ZM16 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421429 1.92172 0 2.93913 0 4V16C0 17.0609 0.421429 18.0783 1.17157 18.8284C1.92172 19.5786 2.93913 20 4 20H16C17.0609 20 18.0783 19.5786 18.8284 18.8284C19.5786 18.0783 20 17.0609 20 16V4C20 2.93913 19.5786 1.92172 18.8284 1.17157C18.0783 0.421427 17.0609 0 16 0Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableCalendarLeft);
export default __webpack_public_path__ + "static/media/disableCalendarLeft.f76afd0921e75286b31edf7bdd16d98a.svg";
export { ForwardRef as ReactComponent };